import { useLocation } from 'react-router-dom';

export function useKioskBasePath(): string {
  const { pathname } = useLocation();
  if (pathname.startsWith('/sing-along/')) return 'sing-along';
  if (pathname.startsWith('/can-you-sing/')) return 'can-you-sing';
  return 'league';
}
